module.exports = __webpack_public_path__ + "img/header-engagementRingsEssentials.15b4787.jpg";